import React, { useEffect, useMemo, useState } from "react";
import bookingconfirmed from "../../assets/bookingconfirmed.jpg";
import pickups from "../../assets/pickups.jpg";
import drops from "../../assets/drops.jpg";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import DaterangePicker from "../../common/Daterangepicker";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import formatDateForApi from "../../common/formatDateForApi";
import { Search } from "lucide-react";
import search from "../../assets/search.jpg";

const Deliveryandpickups = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [cityFilter, setCityFilter] = useState("1");
  let token = localStorage.getItem("token");
  const [deliveryandpickupData, setDeliveryandPIckupData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const rowsPerPage = 10;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  const filteredBookingData = useMemo(() => {
    const bookings = deliveryandpickupData?.bookingData || [];
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return bookings.filter((booking) => {
      const matchesFilter = (() => {
        if (activeFilter === "Home Delivery") {
          return booking?.deliveryTypeText === "Home Delivery";
        }
        if (activeFilter === "Hub Delivery") {
          return booking?.deliveryTypeText === "Hub Delivery";
        }
        if (activeFilter === "Home Pickup") {
          return booking?.pickupTypeText === "Home Pickup";
        }
        if (activeFilter === "Hub Pickup") {
          return booking?.pickupTypeText === "Hub Pickup" ||
            booking?.pickupTypeText === "Hub Drop";
        }
        return true;
      })();

      if (!matchesFilter) return false;

      if (!normalizedSearch) return true;

      const searchableValues = [
        booking?.bookingCode,
        booking?.bookingId,
        booking?.customerName,
        booking?.customerMobile,
        booking?.vehicleName,
        booking?.vehicleRegistrationNo,
      ];

      return searchableValues.some((value) =>
        String(value ?? "").toLowerCase().includes(normalizedSearch),
      );
    });
  }, [deliveryandpickupData?.bookingData, activeFilter, searchTerm]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredBookingData?.length / rowsPerPage),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedVehicles = filteredBookingData.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  useEffect(() => {
    getDeliveryandPickupsDataAPI();
  }, []);

  const getDeliveryandPickupsDataAPI = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&city=${cityFilter}`;
    }
    const url = `${apiUrl}/api/dashboardreports/delivery-pickups?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setDeliveryandPIckupData(data?.dataValues);
        setCurrentPage(1);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };
  const overviewData = {
    counts: [
      {
        title: "Total Bookings",
        value: deliveryandpickupData?.countDetails?.totalBookings || 0,
        image: bookingconfirmed,
        // outof: "Total Bookings",
        class: "text-blue-700",
        bg: "bg-white",
      },
      {
        title: "Enroute Bookings",
        value: deliveryandpickupData?.countDetails?.enrouteBookingsCount || 0,
        image: pickups,
        // outof: `of ${pmsData?.metricsSummary?.statusCounts?.totalVehicles} total Vehicles`,
        class: "text-green-700",
        bg: "bg-white",
      },
      {
        title: "Home Delivery Bookings",
        value:
          deliveryandpickupData?.countDetails?.homeDeliveryBookingsCount || 0,
        image: drops,
        // outof: `of ${pmsData?.metricsSummary?.statusCounts?.totalVehicles} total Vehicles`,
        class: "text-purple-700",
        bg: "bg-white",
      },
      {
        title: "Home Pickup Bookings",
        value:
          deliveryandpickupData?.countDetails?.homePickupBookingsCount || 0,
        image: bookingconfirmed,
        // outof: "Total Bookings",
        class: "text-blue-700",
        bg: "bg-white",
      },
      {
        title: "Hub Delivery Bookings",
        value:
          deliveryandpickupData?.countDetails?.hubDeliveryBookingsCount || 0,
        image: pickups,
        // outof: `of ${pmsData?.metricsSummary?.statusCounts?.totalVehicles} total Vehicles`,
        class: "text-green-700",
        bg: "bg-white",
      },
      {
        title: "Hub Pickup Bookings",
        value: deliveryandpickupData?.countDetails?.hubPickupBookingsCount || 0,
        image: drops,
        // outof: `of ${pmsData?.metricsSummary?.statusCounts?.totalVehicles} total Vehicles`,
        class: "text-purple-700",
        bg: "bg-white",
      },
    ],
  };

  return (
    <>
      {loading ? (
        <>
          <DashboardSkeleton />
        </>
      ) : (
        <>
          <div className="my-4">
            <div className="flex gap-4 p-4 justify-between">
              <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
                Delivery & Pickup
              </h1>

              <div className="flex gap-4">
                {" "}
                <DaterangePicker
                  selectionRange={selectionRange}
                  setSelectionRange={setSelectionRange}
                  style={-10}
                />
                <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                  <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="flex-shrink-0 w-4 h-4"
                    >
                      <path
                        d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                        stroke="#99A1AF"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                        stroke="#99A1AF"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <Citiescommondropdown
                      value={cityFilter}
                      onChange={setCityFilter}
                      options={[
                        { value: null, label: "All Cities" },
                        ...cityOptions,
                      ]}
                      placeholder="City"
                      className="flex-1 min-w-[80px]"
                      showSearch={true}
                    />
                  </div>
                </div>
                <button
                  onClick={() => {
                    getDeliveryandPickupsDataAPI();
                  }}
                  className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  <Search size={18} />
                  Search
                </button>
              </div>
            </div>
          </div>

          <div className="w-full p-6 inline-flex flex-col justify-start items-start gap-8 overflow-hidden">
            <div className="self-stretch inline-flex justify-start items-start gap-4">
              {overviewData &&
                overviewData?.counts.map((data, index) => (
                  <div className="flex-1 p-5 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-3">
                    <div className="self-stretch inline-flex justify-start items-center gap-3">
                      <div className="size-10 bg-blue-50 rounded-[10px] flex justify-center items-center">
                        <div className="size-5 inline-flex flex-col justify-center items-center">
                          <div className="size-5 relative overflow-hidden">
                            <img src={data?.image} alt={data?.title} />
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 justify-start text-slate-500 text-sm font-semibold font-['Inter'] uppercase line-clamp-1">
                        {data?.title}
                      </div>
                    </div>
                    <div className="self-stretch justify-start text-gray-900 text-3xl font-extrabold font-['Inter']">
                      {data?.value}
                    </div>
                  </div>
                ))}
            </div>
            <div className="self-stretch p-6 bg-white rounded-xl shadow-[0px_2px_10px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-200 flex flex-col gap-5">
              {/* Header */}
              <div className="flex justify-between items-center flex-wrap gap-4">
                <div className="flex items-center gap-2 flex-wrap">
                  <button
                    onClick={() => {
                      setActiveFilter("All");
                      setCurrentPage(1);
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold ${activeFilter === "All" ? "bg-blue-600 text-white" : "bg-gray-50 border border-gray-200 text-slate-500"}`}
                  >
                    Confirmed Booking List
                  </button>

                  <button
                    onClick={() => {
                      setActiveFilter("Home Delivery");
                      setCurrentPage(1);
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-medium ${activeFilter === "Home Delivery" ? "bg-blue-600 text-white" : "bg-gray-50 border border-gray-200 text-slate-500"}`}
                  >
                    Home Delivery
                  </button>

                  <button
                    onClick={() => {
                      setActiveFilter("Hub Delivery");
                      setCurrentPage(1);
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-medium ${activeFilter === "Hub Delivery" ? "bg-blue-600 text-white" : "bg-gray-50 border border-gray-200 text-slate-500"}`}
                  >
                    Hub Delivery
                  </button>

                  <button
                    onClick={() => {
                      setActiveFilter("Home Pickup");
                      setCurrentPage(1);
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-medium ${activeFilter === "Home Pickup" ? "bg-blue-600 text-white" : "bg-gray-50 border border-gray-200 text-slate-500"}`}
                  >
                    Home Pickup
                  </button>

                  <button
                    onClick={() => {
                      setActiveFilter("Hub Pickup");
                      setCurrentPage(1);
                    }}
                    className={`px-4 py-2 rounded-lg text-sm font-medium ${activeFilter === "Hub Pickup" ? "bg-blue-600 text-white" : "bg-gray-50 border border-gray-200 text-slate-500"}`}
                  >
                    Hub Pickup
                  </button>
                </div>

                <div className="w-56 px-3 py-2 border border-gray-200 rounded-lg flex items-center gap-2">
                  <img src={search} alt="Search" className="w-4 h-4" />
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                    placeholder="Search by customer, mobile or booking ID"
                    className="flex-1 text-xs outline-none"
                  />
                </div>
              </div>

              {/* Table */}
              <div className="w-full overflow-x-auto">
                <table className="w-full min-w-[1200px] table-fixed border-collapse">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-200">
                      <th className="w-40 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Booking ID
                      </th>

                      <th className="w-40 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Customer Name
                      </th>

                      <th className="w-48 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Vehicle
                      </th>

                      <th className="w-36 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Pickup Date
                      </th>

                      <th className="w-36 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Drop Date
                      </th>

                      <th className="w-36 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Delivery Type
                      </th>

                      <th className="w-36 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Pickup Type
                      </th>

                      <th className="w-40 px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">
                        Status
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedVehicles?.length > 0 ? (
                      paginatedVehicles.map((data, index) => (
                        <tr
                          key={index}
                          className="border-b border-gray-200 hover:bg-gray-50"
                        >
                          <td className="px-4 py-4 text-xs font-bold text-slate-900">
                            {data?.bookingCode}
                          </td>

                          <td className="px-4 py-4 text-xs font-semibold text-slate-900">
                            <div className="truncate">
                              {data?.customerName} ({data?.customerMobile})
                            </div>
                          </td>

                          <td className="px-4 py-4 text-xs font-medium text-slate-900">
                            <div className="truncate">
                              {data?.vehicleName} ({data?.vehicleRegistrationNo}
                              )
                            </div>
                          </td>

                          <td className="px-4 py-4 text-xs text-slate-500">
                            {data?.bookFrom}
                          </td>

                          <td className="px-4 py-4 text-xs text-slate-500">
                            {data?.bookTo}
                          </td>

                          <td className="px-4 py-4 text-xs text-slate-500">
                            {data?.deliveryTypeText}
                          </td>

                          <td className="px-4 py-4 text-xs text-slate-500">
                            {data?.pickupTypeText}
                          </td>

                          <td className="px-4 py-4">
                            <span className="inline-flex px-3 py-1 rounded-md bg-amber-100 text-amber-600 text-xs font-semibold">
                              {data?.statusText}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          className="text-center py-10 text-slate-500"
                        >
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex items-center justify-between border-t border-gray-200 pt-4">
                <div className="text-sm text-slate-500">
                  Showing {filteredBookingData.length > 0 ? startIndex + 1 : 0} -{" "}
                  {filteredBookingData.length > 0
                    ? Math.min(startIndex + rowsPerPage, filteredBookingData.length)
                    : 0}{" "}
                  of {filteredBookingData.length}
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(1, prev - 1))
                    }
                    disabled={currentPage === 1}
                    className="px-4 py-2 border border-gray-300 rounded-md disabled:opacity-50"
                  >
                    Prev
                  </button>

                  <span className="text-sm">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 border border-gray-300 rounded-md disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Deliveryandpickups;
